import { AxiosResponse } from "axios";
import axiosInstance from "./base";
import { TSchedule } from "../shared/types/schedule.type";

export class Stable {

    static getStableRepports(userId?: string): Promise<AxiosResponse<TSchedule[]>> {
        return axiosInstance.get(`send_stable_review_configurations?user=${userId}`)
    }
    static updateStable(id: number, config: Partial<TSchedule>): Promise<AxiosResponse<TSchedule>> {
        return axiosInstance.patch(`send_stable_review_configurations/${id}`, config, {
            headers: {
                'Content-Type': 'application/merge-patch+json',
            }
        })
    }

    static deleteStable(id: number) {
        return axiosInstance.delete(`send_stable_review_configurations/${id}`)
    }

    static saveStable(data: Partial<TSchedule>) {
        return axiosInstance.post(`send_stable_review_configurations`, data)
    }

    static triggerStable(id: number, dates: {
        start_date: string,
        end_date: string
    }) {
        return axiosInstance.post(`send_stable_review_configurations/${id}/manual_trigger`, dates)
    }
}